import plan1 from 'assets/img/planvirtual.png';
import plan2 from 'assets/img/planquiero.png';

export const DATA_PLAN_CARD = [
  {
    id: 0,
    title: 'PLAN VIRTUAL',
    subTitle: 'Todos los obsequios que tus invitados dejen para envío se abonan a tu monedero virtual.',
    linkLabel: 'Crear mesa',
    url: '/crear-mesa',
    image: plan1,
    text: [
      'Todos los regalos que recibas se convierten en abono a un monedero electrónico virtual con código de barras. Con este monedero puedes realizar tus compras en cualquier tienda SEARS y en sears.com.mx',
      'Este plan es ideal si lo que buscas es la flexibilidad de poder cambiar tus regalos por lo que realmente quieras y comprar a tu ritmo.',
      'En este plan tus compras no acumulan bonificaciones extra.',
    ],
  },
  {
    id: 1,
    title: 'PLAN LO QUIERO',
    subTitle: 'Recibe tus obsequios en tu domicilio sin costo adicional.',
    linkLabel: 'Crear mesa',
    url: '/crear-mesa',
    image: plan2,
    text: [
      'Todos los regalos que recibas se envían al domicilio que registres en tu evento totalmente GRATIS.',
      'Este plan es ideal para recibir tus regalos en tu domicilio',
      'En este plan tus compras acumulan bonificaciones en tus compras, las cuales se entregan al cierre del evento a un monedero electrónico virtual.',
      'Los eventos que bonifican son: Boda, Baby Shower, Primera Comunión, Bautizo y XV años.',
    ],
  },
];
